import { useState } from "react";
import { useNavigate } from "react-router-dom";
import PortOne from "@portone/browser-sdk/v2";

const PACKAGES = [
  { id: 'starter', name: '스타터', count: 11, price: 550, priceLabel: '550원', perLabel: '개당 약 50원', refund: false },
  { id: 'regular', name: '레귤러', count: 58, price: 2500, priceLabel: '2,500원', perLabel: '개당 약 43원', refund: true, best: true },
  { id: 'pro', name: '프로', count: 120, price: 4900, priceLabel: '4,900원', perLabel: '개당 약 40원', refund: true },
];

const IconBack = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <mask id="bk" style={{maskType:'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
      <rect width="20" height="20" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#bk)">
      <path d="M11.625 15.7917L5.83333 10L11.625 4.20833L12.8125 5.39583L8.20833 10L12.8125 14.6042L11.625 15.7917Z" fill="#111111"/>
    </g>
  </svg>
);

export default function PaymentPage({ user, fetchCredits }) {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [selectedPkg, setSelectedPkg] = useState(PACKAGES[1]);

  const handlePayment = async () => {
    try {
      const orderId = `order-${Date.now()}`;

      await PortOne.requestPayment({
        storeId: "store-d207997a-3a2f-47f4-824e-b0f2c6a6387e",
        channelKey: "channel-key-9f8c0158-9730-4d97-85f4-2704a8e2b2ba",
        paymentId: orderId,
        orderName: `말투좀요 ${selectedPkg.name} 패키지`,
        totalAmount: selectedPkg.price,
        currency: "CURRENCY_KRW",
        payMethod: "EASY_PAY",
        easyPay: {
          easyPayProvider: "EASY_PAY_PROVIDER_KAKAOPAY",
        },
        redirectUrl: `https://toneplz.vercel.app/payment/success?orderId=${orderId}&pkg=${selectedPkg.id}&method=kakao&userId=${user.id}`,
      });

    } catch (error) {
      alert('결제 중 오류가 발생했어요. 다시 시도해주세요.');
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f0f0f0', display: 'flex', justifyContent: 'center' }}>
      <div style={{ width: '100%', maxWidth: 430, background: '#ffffff', minHeight: '100vh', display: 'flex', flexDirection: 'column', fontFamily: "'DM Mono', monospace" }}>

        <div style={{ background: '#ffffff', borderBottom: '1px solid #111111', height: 52, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 16px', flexShrink: 0 }}>
          <button onClick={() => step === 1 ? navigate('/my') : setStep(1)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center' }}>
            <IconBack />
          </button>
          <span style={{ fontSize: 15, fontWeight: 600, color: '#111111', letterSpacing: 1 }}>말풍선 충전</span>
          <div style={{ width: 20 }} />
        </div>

        <div style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 14, flex: 1 }}>

          {/* 스텝 인디케이터 */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <div style={{ width: 22, height: 22, borderRadius: '50%', background: '#111111', color: '#ffffff', fontSize: 13, fontWeight: 600, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>1</div>
              <span style={{ fontSize: 15, fontWeight: 600, color: '#111111' }}>패키지 선택</span>
            </div>
            <div style={{ flex: 1, height: 1, background: step === 2 ? '#111111' : '#e0e0e0' }} />
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <div style={{ width: 22, height: 22, borderRadius: '50%', background: step === 2 ? '#111111' : '#e0e0e0', color: step === 2 ? '#ffffff' : '#bbbbbb', fontSize: 13, fontWeight: 600, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>2</div>
              <span style={{ fontSize: 15, fontWeight: 600, color: step === 2 ? '#111111' : '#bbbbbb' }}>최종 확인</span>
            </div>
          </div>

          {step === 1 && <>
            <div style={{ background: '#f5f5f5', border: '1px solid #e0e0e0', borderRadius: 12, padding: '10px 12px', display: 'flex', flexDirection: 'column', gap: 4 }}>
              {[
                '말풍선(크레딧)은 <strong>결제일로부터 1년간</strong> 사용 가능하며, 기간 만료 시 자동 소멸됩니다. (자동 갱신 없음)',
                '레귤러/프로는 구매 후 <strong>7일 이내 미사용 시</strong> 전액 환불 가능합니다.',
                '스타터는 소액 패키지로 환불이 어렵습니다.',
                '가입 시 지급된 무료 말풍선은 환불 불가합니다.',
              ].map((item, i) => (
                <div key={i} style={{ fontSize: 13, color: '#555555', lineHeight: 1.6, display: 'flex', gap: 5 }}>
                  <span style={{ color: '#888888', flexShrink: 0 }}>·</span>
                  <span dangerouslySetInnerHTML={{ __html: item }} />
                </div>
              ))}
            </div>

            <div style={{ background: '#ffffff', border: '1px solid #111111', borderRadius: 12, overflow: 'hidden' }}>
              <div style={{ background: '#111111', color: '#ffffff', padding: '9px 14px', fontSize: 15, fontWeight: 600, letterSpacing: 1, borderRadius: '12px 12px 0 0' }}>패키지 선택</div>
              <div style={{ padding: 14, display: 'flex', flexDirection: 'column', gap: 8 }}>
                {PACKAGES.map(pkg => (
                  <div key={pkg.id} onClick={() => setSelectedPkg(pkg)}
                    style={{ border: selectedPkg.id === pkg.id ? '2px solid #111111' : '1px solid #e0e0e0', borderRadius: 8, padding: '11px 12px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: selectedPkg.id === pkg.id ? '#f5f5f5' : '#ffffff' }}>
                    <div>
                      {pkg.best && <div style={{ background: '#111111', color: '#ffffff', fontSize: 13, padding: '2px 8px', borderRadius: 8, marginBottom: 4, display: 'inline-block' }}>인기</div>}
                      <div style={{ fontSize: 15, fontWeight: 600, color: '#111111' }}>{pkg.name}</div>
                      <div style={{ fontSize: 13, color: '#888888', marginTop: 2 }}>💬 {pkg.count}개</div>
                      <div style={{ fontSize: 13, color: '#bbbbbb', marginTop: 2 }}>{pkg.perLabel}</div>
                      {!pkg.refund && <div style={{ fontSize: 13, color: '#bbbbbb', marginTop: 2 }}>환불 불가</div>}
                    </div>
                    <div style={{ fontSize: 16, fontWeight: 700, color: '#111111' }}>{pkg.priceLabel}</div>
                  </div>
                ))}
              </div>
            </div>

<div style={{ background: '#ffffff', border: '1px solid #e0e0e0', borderRadius: 12, padding: '10px 12px', display: 'flex', alignItems: 'center', gap: 8 }}>
  <div style={{ width: 34, height: 34, borderRadius: 12, background: '#FEE500', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, fontWeight: 700, color: '#3A1D1D', flexShrink: 0 }}>K</div>
  <div>
    <div style={{ fontSize: 15, fontWeight: 600, color: '#111111' }}>카카오페이</div>
    <div style={{ fontSize: 13, color: '#bbbbbb', marginTop: 1 }}>현재 카카오페이만 지원합니다. 추후 다양한 결제수단이 추가될 예정이에요.</div>
  </div>
</div>

            <button onClick={() => setStep(2)}
              style={{ width: '100%', background: '#111111', color: '#ffffff', border: 'none', borderRadius: 8, padding: '15px 20px', fontSize: 15, fontWeight: 700, cursor: 'pointer', fontFamily: "'DM Mono', monospace" }}>
              다음 →
            </button>
          </>}

          {step === 2 && <>
            <div style={{ background: '#ffffff', border: '1px solid #111111', borderRadius: 12, overflow: 'hidden' }}>
              <div style={{ background: '#111111', color: '#ffffff', padding: '9px 14px', fontSize: 15, fontWeight: 600, letterSpacing: 1, borderRadius: '12px 12px 0 0' }}>최종 확인</div>
              <div style={{ padding: 14 }}>
                <div style={{ background: '#f5f5f5', borderRadius: 12, padding: 14, display: 'flex', flexDirection: 'column', gap: 7 }}>
                  {[
                    ['패키지', selectedPkg.name],
                    ['말풍선', `${selectedPkg.count}개`],
                    ['결제수단', '카카오페이'],
                  ].map(([k, v]) => (
                    <div key={k} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 15, color: '#555555' }}>
                      <span>{k}</span><span>{v}</span>
                    </div>
                  ))}
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 15, fontWeight: 700, color: '#111111', borderTop: '1px solid #e0e0e0', paddingTop: 7, marginTop: 2 }}>
                    <span>결제 금액</span><span>{selectedPkg.priceLabel}</span>
                  </div>
                </div>
                <div style={{ fontSize: 13, color: '#bbbbbb', textAlign: 'center', marginTop: 10, lineHeight: 1.6 }}>결제 시 환불 정책에 동의한 것으로 간주됩니다.</div>
              </div>
            </div>

            <button onClick={handlePayment}
              style={{ width: '100%', background: '#FEE500', color: '#3A1D1D', border: '1px solid #111111', borderRadius: 8, padding: '15px 20px', fontSize: 15, fontWeight: 700, cursor: 'pointer', fontFamily: "'DM Mono', monospace" }}>
              카카오페이로 {selectedPkg.priceLabel} 결제하기
            </button>
          </>}

        </div>
      </div>
    </div>
  );
}